import { LoadState } from "../../constants/enums";
import {
  IMrpAllocation,
  IMrpAllocationItem,
  IMrpAllocationsState,
  IMrpPartCodeDescription,
} from "./mrp-allocations.types";

export const defaultMRPAllocationItem: IMrpAllocationItem = {
  serial_no: "",
  unit: "",
  level: "",
  meaning: "",
  item_type: "",
  part_code: "",
  alternate_code: 0,
  alternate_part_codes: [],
  part_name: "",
  product_d: 0,
  product_h: 0,
  product_w: 0,
  drawing_no: "",
  drawing_name: "",
  drawing_uuid: "",
  bom_item_uuid: null,
  quantity_per_unit: 0,
  stock: 0,
  remark: "",
  origin: "",
  allocated: 0,
  transit: 0,
  transit_quantity: 0,
  allocated_quantity: 0,
  warehouse_quantity: 0,
  git_quantity: 0,
  create_ts: "",
  created_by_uuid: "",
  insert_ts: "",
  material_allocation_type: null,
  material_allocation_uuid: "",
  mrp_allocation_uuid: "",
  order_no: "",
  part_item_name: "",
  part_item_uuid: "",
  product_code: "",
  quantity: 0,
  status: "ACTIVE",
};

export const defaultMRPAllocation: IMrpAllocation = {
  mrp_allocation_uuid: null,
  order_no: "",
  bom_uuid: null,
  product_code: null,
  product_size: null,
  series: null,
  rev_no: null,
  effective_date: null,
  description: null,
  add: null,
  change: null,
  delete: null,
  prepared_by_uuid: null,
  prepared_by_name: null,
  checked_by_uuid: null,
  checked_by_name: null,
  approved_by_uuid: null,
  approved_by_name: null,
  excel_link: null,
  product_items: [],
  status: "MRP_ALLOCATION_REQUESTED",
  region: null,
};

export const defaultPartCodeDescription: IMrpPartCodeDescription = {
  part_item_description_uuid: "",
  part_item_uuid: "",
  part_code: "",
  part_name: "",
  minimum_order_quantity: 0,
  last_price: 0,
  average_consumption: null,
  movement: "",
  issuance_date: null,
  wap: 0,
  finished_goods: 0,
  additional_classifications: [],
  status: "",
  created_by_uuid: "",
};
export const defaultMRPAllocationState: IMrpAllocationsState = {
  mrp_allocations_list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  single_mrp_allocation: {
    data: defaultMRPAllocation,
    loading: LoadState.NotLoaded,
    error: null,
    meta: "",
  },
  single_order_mrp_allocations: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  mrp_part_code_description: {
    data: defaultPartCodeDescription,
    loading: LoadState.NotLoaded,
    error: null,
  },
  single_order_cons_mrp_alloc_list: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
